import {
	GuarantorEntityType,
	PatientEntityType,
	PractitionerEntityType,
} from "@/lib/supabase/supabaseTypes";
import { PdfLetterhead } from "../pdf-template-components/pdf-letterhead.component";
import { PdfLayout } from "../pdf-template-components/pdf-layout.component";
import { PdfRecipientAddress } from "../pdf-template-components/pdf-recipient-address.component";
import { PdfJobInformation } from "../pdf-template-components/pdf-job-information.component";
import { PdfTitleAndDate } from "../pdf-template-components/pdf-title-and-date.component";
import { PdfJobItemsTable } from "../pdf-template-components/job-items-table/pdf-job-items-table";
import { PdfTemplateType } from "../document-template.types";
import "../fonts.css";
import { CommonPDFTemplateProps } from "./types";
import { PdfFooter } from "../pdf-template-components/pdf-footer.component";
import { getRecipient } from "../utils";
import { useCurrencyHierarchy } from "../../lib/utils/region-utils";
export interface GutschriftTemplateProps extends CommonPDFTemplateProps {
	patient?: PatientEntityType;
	guarantor?: GuarantorEntityType;
	practitioner?: PractitionerEntityType;
}

export const GutschriftTemplate: React.FC<GutschriftTemplateProps> = ({
	client,
	job,
	jobDocument,
	jobItems,
	organization,
	pdfTemplateConfiguration,
	currencyConverterValues,
	patient,
	guarantor,
	practitioner,
	jobTotals,
}) => {
	const currency = useCurrencyHierarchy(job, client);
	if (
		!organization ||
		!pdfTemplateConfiguration ||
		!job ||
		!jobDocument ||
		!jobItems ||
		!client
	) {
		return null;
	}
	return (
		<PdfLayout pdfTemplateConfiguration={pdfTemplateConfiguration}>
			<PdfLetterhead
				organization={organization}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				pdfType={PdfTemplateType.GUTSCHRIFT}
				mwstNumber={
					job.mwst_number ??
					client.mwst_number ??
					organization.mwst_number ??
					""
				}
			/>
			<PdfRecipientAddress
				recipient={getRecipient({
					job,
					patient,
					guarantor,
					client,
					templateType: PdfTemplateType.GUTSCHRIFT,
				})}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				template={PdfTemplateType.GUTSCHRIFT}
			/>
			<div
				aria-label="Dokumenteninhalt"
				style={{
					paddingTop: "5mm",
					paddingLeft: "5mm",
					paddingRight: "10mm",
				}}
			>
				<PdfTitleAndDate
					generalConfig={pdfTemplateConfiguration.general}
					title={jobDocument?.title ?? "Gutschrift"}
					date={jobDocument?.date}
				/>
				<div
					aria-label="Zusatzinformationen"
					style={{
						paddingTop: "5mm",
						fontSize: "10pt",
					}}
				>
					<PdfJobInformation
						generalConfig={pdfTemplateConfiguration.general}
						pdfTemplateType={PdfTemplateType.GUTSCHRIFT}
						client={client}
						job={job}
						jobItems={jobItems}
						patient={patient}
						practitioner={practitioner}
						pdfTemplateConfiguration={pdfTemplateConfiguration}
					/>
				</div>
				<div
					style={{
						paddingTop: "5mm",
						fontSize: "10pt",
					}}
				>
					{jobItems && job && (
						<PdfJobItemsTable
							pdfTemplateConfiguration={pdfTemplateConfiguration}
							jobTotals={jobTotals}
							jobDocument={jobDocument}
							jobItems={jobItems}
							organization={organization}
							showDrTax={true}
							isMwstEust={
								job.is_mwst_eust ??
								client.is_mwst_eust ??
								organization.is_mwst_eust ??
								false
							}
							templateType={PdfTemplateType.GUTSCHRIFT}
							currency={currency}
						/>
					)}
				</div>
				<PdfFooter
					templateType={PdfTemplateType.GUTSCHRIFT}
					pdfTemplateConfiguration={pdfTemplateConfiguration}
					jobDocument={jobDocument}
					client={client}
					currencyConverterValues={currencyConverterValues}
				/>
			</div>
		</PdfLayout>
	);
};
